// textNode.js
import { useState, useEffect, useRef } from 'react';
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';
import { Label } from '../components/ui/Label';
import { useStore } from '../store';

export const TextNode = ({ id, data }) => {
  const [currText, setCurrText] = useState(data?.text || '{{input}}');
  const [handles, setHandles] = useState([]);
  const textareaRef = useRef(null);
  const updateNodeField = useStore((state) => state.updateNodeField);

  // Auto-resize logic
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [currText]);

  // Handle extraction logic
  useEffect(() => {
    const variableRegex = /\{\{\s*([a-zA-Z_$][a-zA-Z0-9_$]*)\s*\}\}/g;
    const matches = [...currText.matchAll(variableRegex)];
    const variables = [...new Set(matches.map(m => m[1]))];

    const newHandles = variables.map((variable, index) => ({
      type: 'target',
      position: Position.Left,
      id: `${id}-${variable}`,
      style: { top: `${(index + 1) * (100 / (variables.length + 1))}%` }
    }));

    newHandles.push({ type: 'source', position: Position.Right, id: `${id}-output` });
    setHandles(newHandles);
  }, [currText, id]);

  return (
    <BaseNode
      id={id}
      data={data}
      title="Text"
      handles={handles}
    >
      <div className="flex flex-col gap-1">
        <Label>Text</Label>
        <textarea
          ref={textareaRef}
          value={currText}
          onChange={(e) => {
            setCurrText(e.target.value);
            updateNodeField(id, 'text', e.target.value);
          }}
          className="nowheel nodrag w-full rounded-md border border-gray-600 bg-gray-800 text-white px-3 py-2 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 overflow-hidden resize-none min-h-[40px]"
        />
      </div>
    </BaseNode>
  );
}
